/* tslint:disable */
import { Injectable, ComponentFactoryResolver, Optional } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import 'rxjs/add/operator/map';
// import { Http, Headers, Response, URLSearchParams, RequestOptions } from '@angular/common/http';
import { Component, OnInit, Input, HostListener, AfterViewInit } from '@angular/core';
import { Router, ActivatedRoute, ActivatedRouteSnapshot } from "@angular/router";
import { DomStorageFallbackService } from './DomStorageFallback.service';
import { LoggingService } from './logging/logging.service';
import { LoggingConstants } from '../constants/logging-constant';
import { IUrlOptions } from '../models/rest.caller.model';
import { AppUtility } from '../utils/utility';
/* istanbul ignore next */
import { RemoteService } from './remote.service';
import { Subject } from 'rxjs';

@Injectable()
export class GenericService {

  // Value of below keys in the response will not be converted to routers.
  // DCH-1404, DCH-1118
  public ignoreKeysForRouter = ['allLRServiceAccounts', 'accounts', 'hrbpoRoleAccount', 'tbaAcctsForDisplay', 'bpoAcctsForEcsCssoDisplay'];
  public otherRresourcesUsedMap = [];
  private ivaJSSrc: string;
  public subject = new Subject();
  public intializeTransmitSubject = new Subject();
  includeIVAJs: boolean;

  /* istanbul ignore next */
  constructor(
    private domStorageFB: DomStorageFallbackService,
    private router: Router,
    private componentFactoryResolver: ComponentFactoryResolver,
    private loggingService: LoggingService,
    @Optional() private remoteService: RemoteService,
    @Optional() private appUtility: AppUtility
  ) { }

  /* istanbul ignore next */
  public getRouterConfiguration(res) {
    let exprSet = new Set();
    let exprMap = {};
    let serviceUrl = "";
    let lineage = this.getClientId() + "_1.0";
    serviceUrl = 'channel/widgetconfigurations/channel/configurationList/get/public';
    let routeDefinition;

    for (var i in res) {
      if (res[i].assetRouters) {
        if (res[i].assetRouters.routes) {
          routeDefinition = res[i].assetRouters.routes;
          sessionStorage.setItem('routeDefinition', JSON.stringify(routeDefinition));
          for (var key in routeDefinition) {
            let routeDefinitionObj = routeDefinition[key];
            if (routeDefinitionObj['flavours']) {
              let flavors = routeDefinitionObj['flavours'];
              for (let flavour in flavors) {
                let flavourObj = flavors[flavour];
                //if (flavourObj['flavourName'] !== 'DEFAULT') {
                exprSet.add(flavourObj['expr']);
                //}
              }
            }
          }
        }
        break;
      }
    }

    if (res[0].expr['ADOPT_UPOINT_REDESIGN']) {
      this.domStorageFB.setItem("ADOPT_UPOINT_REDESIGN", res[0].expr['ADOPT_UPOINT_REDESIGN']);
    }
    let experKeys = [];
    const options: IUrlOptions = {
      restOfUrl: '',
      endPoint: serviceUrl,
      isSecure: true,
      contentType: 'application/json'
    };
    if (exprSet.size > 0) {
      exprSet.forEach((expr) => {
        experKeys.push({ 'name': expr, 'type': 'regular' });
      });
      let requestBody = {
        'lineage': lineage,
        'locale': 'en_US',
        'operation': 'configset',
        'exprKeys': experKeys
      };
      this.remoteService.request('post', options, requestBody).toPromise().then((respData) => {
        let exprObj = respData[0];
        if (exprObj !== undefined) {
          let exprMapObj = exprObj['expr'];
          sessionStorage.setItem("expValueMap", JSON.stringify(exprMapObj));
        }
      });
    }

  }

  /* istanbul ignore next */
  public splitHref(linkHref: string) {
    const queryParam: any = {};
    const routerObj: any = {};
    if (linkHref !== undefined) {
      if (linkHref.indexOf('?') !== -1) {
        let hrefquery = linkHref.split('?');
        routerObj.routerLink = hrefquery[0];
        routerObj.queryParam = hrefquery[1];
      }
    }

    return routerObj;
  }


  /* istanbul ignore next */
  public makeAngularRouterLink(value) {
    let str = value;
    let isString = typeof value;
    let angularRouterLink = value;
    let hrefValue = str.substring(str.indexOf("href=\"") + 6, str.indexOf("\"", str.indexOf("href=\"") + 6));
    let hrefParts = this.splitHref(hrefValue);
    let languageId = this.getLanguageId();
    const lssValue = this.domStorageFB.getItem('LSS', '', true);
    //let hrefquery = hrefValue.split('?');
    let onclickvariable = str.substring(str.indexOf("onclick=\"") + 9, str.indexOf("\"", str.indexOf("onclick=\"") + 9));
    if (hrefParts.queryParam) {
      var queryParamJsonData = {};

      var queryParamParts = hrefParts.queryParam.split('&');
      for (let queryParam of queryParamParts) {
        let param = queryParam.split("=");
        if (param !== undefined && param !== null) {
          queryParamJsonData[param[0]] = param[1];
        }
      }
      let displayText = str.substring(str.indexOf('>') + 1, str.toLowerCase().indexOf('</a>'));
      let linkId = this.getLinkId(hrefParts.queryParam);
      if (this.ifPageIsConverted(linkId)) {
        let queryParamsJson = "{href:'" + hrefValue + "'}";
        if (lssValue !== undefined && lssValue === 'true') {
          let redirecturl = this.getAngularFirstUrl() + "#" + hrefValue;
          angularRouterLink = '<a ' + ' href="' + redirecturl + "" + "&languageId=" + languageId + '">' + displayText + '</a>';
        }
        else {
          angularRouterLink = '<a [routerLink]="[' + "'" + hrefParts.routerLink + "'" + ']" [queryParams]= ' + "'" + JSON.stringify(queryParamJsonData) + "'" + '>' + displayText + '</a>';
        }
        this.loggingService._debug("angular router link:" + angularRouterLink, "GenericSrvice", LoggingConstants.DEBUG);
      }
      else {
        let replaceHrefValue = hrefValue + "" + "&languageId=" + languageId;
        angularRouterLink = angularRouterLink.replace(hrefValue, replaceHrefValue);
        //angularRouterLink = '<a ' + 'onclick=' + '"' + onclickvariable + '"' + ' href="' + hrefValue+"" +"&languageId="+languageId+ '">' + displayText + '</a>';
      }
    }

    return angularRouterLink;
  }

  /* istanbul ignore next */
  public getClientId() {
    let alightRequestHeader;
    let clientId;
    if (this.domStorageFB.getItem('alightRequestHeader')) {
      alightRequestHeader = JSON.parse(this.domStorageFB.getItem('alightRequestHeader'));
      if (alightRequestHeader.clientId) {
        clientId = alightRequestHeader.clientId;
        return clientId;
      } else {
        return JSON.parse(this.domStorageFB.getItem('lr_json_data')).lineage.split('_')[0];
      }
    }
  }

  //updated methods for handling links,asset,value keys
  /* istanbul ignore next */
  public getAngularRouterLinksU(coreJsons, widgetKey) {
    if (LoggingService.uConsole) {
      console.log('Making angular router links with data= ' + coreJsons);
    }
    Object.keys(coreJsons).forEach(coreKeyParse => {
      let coreJsonParse = coreJsons[coreKeyParse];
      Object.keys(coreJsonParse).forEach(coreKey => {

        // DCH-1118
        if (this.ignoreKeysForRouter.indexOf(coreKey) > -1) {
          return;
        } else {
          let coreJson = coreJsonParse[coreKey];
          try {
            this.parseJson(coreJson, widgetKey);
          } catch (e) {
            console.log("exception while parsing JSON -fn getAngularRouterLinksU" + coreJson);
            console.log("exception occured - fn getAngularRouterLinksU" + e);
          }
        }
      });
    });
    return coreJsons;
  }
  /* istanbul ignore next */
  public parseJson(coreJson, widgetKey) {
    if (coreJson !== null && coreJson !== undefined) {
      if (Object.keys(coreJson).length > 0) {
        Object.keys(coreJson).forEach(key1 => {
          let value1 = coreJson[key1];
          let typeOfvalue = typeof value1;
          // caseI
          if (widgetKey.indexOf(key1) !== -1) {
            if (value1 !== null && value1 !== '') {
              if (typeOfvalue.toLowerCase() === 'object' || typeOfvalue.toLowerCase() === 'array') {
                Object.keys(coreJson[key1]).forEach(routeKey => {
                  let newRouteKey = this.makeAngularRouterLinkU(routeKey);
                  coreJson[key1][newRouteKey] = coreJson[key1][routeKey];
                  if (newRouteKey !== routeKey) {
                    delete coreJson[key1][routeKey];
                  }
                })
              } else if (typeOfvalue.toLowerCase() === 'string') {
                coreJson[key1] = this.makeAngularRouterLinkU(value1);
              }
            }
          } else {
            if (value1 !== null && value1 !== '') {
              if (typeOfvalue.toLowerCase() === 'object' || typeOfvalue.toLowerCase() === 'array') {
                this.parseJson(value1, widgetKey);
              }
            }
          }

        });
      }
    }
  }

  /* istanbul ignore next */
  public makeAngularRouterLinkU(value) {
    if (LoggingService.uConsole) {
      console.log('Making  router links with value= ' + value);
    }
    let isString = typeof value;
    if (isString === 'string' && value.toLowerCase().indexOf('invalid link') > 0) {
      let invalidLink = '<a [routerLink]="[invalidLink]" [queryParams]= "">INVALID</a>';
      return invalidLink;
    } else if (isString === 'string' && value.toLowerCase().trim().indexOf('<a') === 0) {
      let anchorRouterLink = this.makeAngularRouterLink(value);
      return anchorRouterLink;
    } else if (isString === 'string' && value.toLowerCase().indexOf('{') === 0 && value.toLowerCase().indexOf('href') > 0) {
      let angularRouterLink = value;
      let keyJson = JSON.parse(value);
      let hrefValue = keyJson.href;
      let hrefParts = this.splitHref(hrefValue);
      const lssValue = this.domStorageFB.getItem('LSS', '', true);
      if (hrefParts.queryParam) {
        var queryParamJsonData = {};

        var queryParamParts = hrefParts.queryParam.split('&');
        for (let queryParam of queryParamParts) {
          let param = queryParam.split("=");
          if (param !== undefined && param !== null) {
            queryParamJsonData[param[0]] = param[1];
          }
        }
        let displayText = keyJson.displayText;
        let afFirst = '';
        let onClick = keyJson.onclick;

        let linkId = this.getLinkId(hrefParts.queryParam);
        let languageId = this.getLanguageId();
        queryParamJsonData["languageId"] = languageId;
        if (this.ifPageIsConverted(linkId)) {
          let queryParamsJson = "{href:'" + hrefValue + "'}";
          if (lssValue !== undefined && lssValue === 'true') {
            let redirecturl = this.getAngularFirstUrl() + "#" + hrefValue;
            angularRouterLink = '<a ' + ' href="' + redirecturl + "" + "&languageId=" + languageId + '">' + displayText + '</a>';
          }
          else {
            angularRouterLink = '<a [routerLink]="[' + "'" + hrefParts.routerLink + "'" + ']" [queryParams]= ' + "'" + JSON.stringify(queryParamJsonData) + "'" + '>' + displayText + '</a>';
          }
          this.loggingService._debug("angular router link:" + angularRouterLink, "GenericSrvice", LoggingConstants.DEBUG);
        } else {
          angularRouterLink = '<a ' + 'onclick=' + '"' + keyJson.onclick + '"' + ' href="' + hrefValue + "" + "&languageId=" + languageId + '">' + displayText + '</a>';
        }
        return angularRouterLink;
      }
    }
    return value;
  }

  /* istanbul ignore next */
  public getLinkId(hrefquery) {
    let linkIdString = hrefquery.toLowerCase();

    let linkid;
    if (linkIdString.indexOf('linkid=') != -1) {
      linkid = linkIdString.substring(linkIdString.indexOf('linkid=') + 7);
    }

    let linkTechnicalName;
    if (linkIdString.indexOf('technicalnameforlink=') != -1) {
      linkTechnicalName = linkIdString.substring(linkIdString.indexOf('technicalnameforlink=') + 21);
    }

    if (linkid) {
      linkid = linkid.substring(0, linkid.indexOf('&'));
      linkid = linkid.toUpperCase();
    } else {
      if(linkTechnicalName)
      {
        linkTechnicalName = linkTechnicalName.substring(0, linkTechnicalName.indexOf('&'));
        linkid = linkTechnicalName.toUpperCase();
      }
    }
    return linkid;

  }

  /* istanbul ignore next */
  public ifPageIsConverted(linkId: string) {
    let clientId: any = this.getClientId();
    let storeData = new Map();
    let routeData: any = [];
    let routeValue;
    let excludedClientsArray;
    let indexOfExClient;
    let routeDefinition = sessionStorage.getItem('routeDefinition');

    if (routeDefinition !== undefined && routeDefinition !== null && Object.keys(routeDefinition).length > 0) {
      let routeDefinitionJson = JSON.parse(routeDefinition);

      Object.keys(routeDefinitionJson).forEach(routeKey => {
        routeValue = routeDefinitionJson[routeKey];
        let linkidValues;
        linkidValues = routeValue.links;
        if (linkidValues !== undefined && linkidValues.length > 0) {
          Object.keys(linkidValues).forEach(link => {
            let jsonObj = {};
            jsonObj[linkidValues[link]] = routeValue;
            routeData.push(jsonObj);
          });
        }
      });
    }

    for (var key in routeData) {
      for (var id in routeData[key]) {
        if (id === linkId) {
          routeValue = routeData[key][linkId];
          break;
        } else {
          // if linkid not matched then set routevalue to undefined in non page converted case
          routeValue = undefined;
        }
      }
      if (routeValue) {
        break;
      }
    }
    

    if (routeValue !== undefined) {
      if (routeValue.excludedClient !== undefined) {
        excludedClientsArray = routeValue.excludedClient.trim().split(',');
        indexOfExClient = excludedClientsArray.indexOf(clientId);
      }
    }

    if (routeValue !== undefined && (indexOfExClient === undefined || (indexOfExClient !== undefined && indexOfExClient === -1))) {
      return true;
    } else {
      return false;
    }
  }


  /* istanbul ignore next */
  public getUpointNextUrl() {
    let protocol = window.location.protocol;
    let hostname = window.location.hostname;
    let port = window.location.port;
    let upointNextUrl = '';
    let host = document.location.host;

    if (port) {
      upointNextUrl = protocol + '//' + host;
    } else {
      upointNextUrl = protocol + '//' + hostname;
    }

    return upointNextUrl;
  }

  /* istanbul ignore next */
  public getAngularFirstUrl() {
    let afUrl = this.getUpointNextUrl() + "/ah-angular-afirst-web/";
    return afUrl;
  }

  /* istanbul ignore next */
  public getLanguageId() {
    let languageId = '';
    if (this.domStorageFB.getItem('lr_json_data') && JSON.parse(this.domStorageFB.getItem('lr_json_data')).locale) {
      const lrJsonData = JSON.parse(this.domStorageFB.getItem('lr_json_data'));
      if (lrJsonData['locale']) {
        if (LoggingService.uConsole) {
          console.log('locale value=' + lrJsonData['locale']);
        }
        languageId = lrJsonData['locale'];
      }
    }
    else {
      if(this.domStorageFB.getItem('alightRequestHeader') && JSON.parse(this.domStorageFB.getItem('alightRequestHeader')).locale){
        languageId = JSON.parse(sessionStorage.getItem("alightRequestHeader")).locale;
      }
    }
    return languageId;
  }

  /* istanbul ignore next */
  public getOrgName() {
    if (this.domStorageFB.getItem('lr_json_data') && JSON.parse(this.domStorageFB.getItem('lr_json_data')).orgName) {
      return JSON.parse(this.domStorageFB.getItem('lr_json_data')).orgName;
    }
    else {
      return window.location.href.split('/web/')[1].split('/')[0];
    }
  }

  /* istanbul ignore next */
  public getServiceClients() {
    let serviceClientData;
    let clientId;
    let alightReqHeader = JSON.parse(this.domStorageFB.getItem('alightRequestHeader'));
    if (!this.domStorageFB.getItem('serviceClients')) {
      let orgName = this.getOrgName();
      const endUrl = 'channel/clientappconfigurations/upoint/clientsetup/clientname/' + orgName;
      this.remoteService.request('get', {
        restOfUrl: '', endPoint: endUrl, isSecure: true,
        contentType: 'application/json'
      }).subscribe((response) => {
        const json = response;
        /* istanbul ignore next */
        try {
          this.domStorageFB.setItem('serviceClients', JSON.stringify(json));
          if (this.domStorageFB.getItem('serviceClients')) {
            serviceClientData = JSON.parse(this.domStorageFB.getItem('serviceClients'));
            if(serviceClientData['clientsetup']){
              if (serviceClientData.clientsetup['primary.clientId']) {
                clientId = serviceClientData.clientsetup['primary.clientId'];
                if ((clientId === '' || clientId === null || !clientId) && serviceClientData.clientsetup['clientId.CM']) {
                  clientId = serviceClientData.clientsetup['clientId.CM'];
                }
                alightReqHeader['clientId'] = clientId;
                this.domStorageFB.setItem('alightRequestHeader', JSON.stringify(alightReqHeader));
              }
            }
          }
        } catch (error) {
          if (LoggingService.uConsole) {
            console.log('Error in getServiceClients() function == ', error);
          }
        }
      },
        (error) => {
          this.loggingService._error(JSON.stringify(error), 'service invocation failed with' +
            'response in genericService', LoggingConstants.ERROR, 'genericService');
        });
    }else{
      if (this.domStorageFB.getItem('serviceClients')) {
        serviceClientData = JSON.parse(this.domStorageFB.getItem('serviceClients'));
        if(serviceClientData['clientsetup']){
          if (serviceClientData.clientsetup['primary.clientId']) {
            clientId = serviceClientData.clientsetup['primary.clientId'];
            if ((clientId === '' || clientId === null || !clientId) && serviceClientData.clientsetup['clientId.CM']) {
              clientId = serviceClientData.clientsetup['clientId.CM'];
            }
            alightReqHeader['clientId'] = clientId;
            this.domStorageFB.setItem('alightRequestHeader', JSON.stringify(alightReqHeader));
          }
        }
      }
    }
  }

  /* istanbul ignore next */
  public setIVAJsSRc(ivaJsSrc: string){
    this.ivaJSSrc = ivaJsSrc;
  }

  /* istanbul ignore next */
  public getIVAJsSRc(){
      return this.ivaJSSrc;
  }
  /* istanbul ignore next */
  public getQueryParamValue(field, url) {
    let href = url ? url : window.location.href;
    let reg = new RegExp('[?&]' + field + '=([^&#]*)', 'i');
    let string = reg.exec(href);
    return string ? string[1] : null;
  }
  /* istanbul ignore next  */
  public cleanDescription(href: string): string {
    let newValue = href;
    if (newValue !== null && newValue !== '' ) {
      let indexUser = newValue.lastIndexOf('&userFriendlyNameForLink=');
      let indexDomain = newValue.lastIndexOf('&domain=');
      if (indexUser > -1 && indexDomain > -1 && indexUser < indexDomain) {
        let strOrg = newValue.substring(indexUser, indexDomain);
        let str = strOrg;
        str = str.replace(/['"]+/g,  ''); 
        str = str.replace(/[\\]+/g,  ''); 
        newValue = newValue.replace(strOrg, str);
      }
    }
    return newValue;
  }
  /* istanbul ignore next  */
  public getRouterQueryParamObj(href: String) {
    const queryParamJsonData = {};
    if (href) {
      if (href.indexOf('&') !== -1) {
        const queryParamParts = href.split('&');
        for (const queryParam of queryParamParts) {
          const param = queryParam.split('=');
          if (param !== undefined && param !== null) {
            queryParamJsonData[param[0]] = param[1];
          }
        }
      } else {
        const param = href.split('=');
        if (param !== undefined && param !== null) {
          queryParamJsonData[param[0]] = param[1];
        }
      }
    }
    return queryParamJsonData;
  }
   /* istanbul ignore next */
   public analyticstpaTool(): any {

    let endPointUrl = 'channel/widgetconfigurations/channel/widgetConfigurations/analyticstpa';

    if (this.appUtility.isPreAuth()) {
      endPointUrl = 'channel/widgetconfigurations/channel/widgetConfigurations/analyticstpa/public';
    }
    try {
      /* istanbul ignore next */
      const ibmfraudAssetResolver = JSON.parse(this.domStorageFB.getItem('ibmfraudAssetResolver'))
       if (ibmfraudAssetResolver) {
         if (ibmfraudAssetResolver[0].expr['IBM_TRSTR_DETECT_ENABLE']) {
           if (!this.appUtility.isLiferay()) {
             this.analyticstpaToolJS();
           }
         }
       }
       else {
      return this.remoteService.request('get', {
        restOfUrl: '',
        endPoint: endPointUrl, isSecure: true, contentType: 'application/json'
      })
        .subscribe((res) => {
          this.domStorageFB.setItem('ibmfraudAssetResolver', JSON.stringify(res), '', true);
          //      const  ibmresponse = JSON.parse(res);
          if (res && res[0] && res[0].expr['IBM_TRSTR_DETECT_ENABLE']) {
            if (this.appUtility.isPreAuth() && !this.appUtility.isLiferay()) {
            this.analyticstpaToolJS();
          }

        }
          return res;
        }, err => {
          if (LoggingService.uConsole) {
            console.log('analyticstpaTool method error block ::', err);
          }
        });
      }
    } catch (error) {
      this.loggingService._error('Exception occurred in analyticstpaToolJS'
        + error, endPointUrl, LoggingConstants.ERROR);
    }

  }
  /* istanbul ignore next */
  analyticstpaToolJS() {

    const app_url = this.domStorageFB.getItem('app_url', '', );
    if (app_url) {
      const source = app_url + 'al-assets/js/analytics-tpa-tool.js';
      if (LoggingService.uConsole) {
        console.log('analyticstpaToolJS() - dynamicly add the script - ' + source);
      }

      const headTag = document.getElementsByTagName('head')[0];
      const scriptTag = document.createElement('script');
      scriptTag.setAttribute('type', 'text/javascript');
      scriptTag.setAttribute('language', 'javascript');
      scriptTag.setAttribute('async', 'true');
      scriptTag.setAttribute('src', source);
      headTag.appendChild(scriptTag);
    }
  }
   /* istanbul ignore next */
   public getClientAndTitle(): any {
    let pageGroupUrl = 'channel/widgetconfigurations/channel/configurationList/get';
    let lineage = this.getClientId() + '_1.0';
    if (this.appUtility.isPreAuth()) {
      pageGroupUrl = 'channel/widgetconfigurations/channel/configurationList/get/public';
      if (LoggingService.uConsole) {
        console.log('getClientAndTitle :Inside preauth');
      }
      lineage = this.getClientId() + '_1.0';
    }
    const options: IUrlOptions = {
      restOfUrl: '',
      endPoint: pageGroupUrl,
      isSecure: true,
      contentType: 'application/json'
    };

    let textKey = [];
    let paramKey = [];

    textKey.push({ 'name': 'PAGE_TITLE_HOME'});
    textKey.push({ 'name': 'PAGE_TITLE_LOGIN'});
    paramKey.push({ 'name': 'Company_Name'});

    let requestBody = {
      'lineage': lineage,
      'locale': this.getLanguageId(),
      'operation': 'configset',
      'paramKeys': paramKey,
      'textKeys': textKey
    };
    this.remoteService.request('post', options, requestBody).subscribe((respData) => {
      if (respData !== undefined && respData._body !== undefined) {
        if (JSON.parse(respData._body)[0].text !== undefined) {
          this.domStorageFB.setItem('PAGE_TITLE_HOME', JSON.parse(respData._body)[0].text['PAGE_TITLE_HOME']);
          this.domStorageFB.setItem('PAGE_TITLE_LOGIN', JSON.parse(respData._body)[0].text['PAGE_TITLE_LOGIN']);
        }
        if (JSON.parse(respData._body)[0].param !== undefined) {
          this.domStorageFB.setItem('Company_Name', JSON.parse(respData._body)[0].param['Company_Name'].val);
        }
      }
    });
  }

  public resolveAssetOfAssetGroup(assetGroup): any {
    let pageGroupUrl = 'channel/widgetconfigurations/channel/configurationList/get';
    let lineage = this.getClientId() + '_1.0';
    if (this.appUtility.isPreAuth()) {
      pageGroupUrl = 'channel/widgetconfigurations/channel/configurationList/get/public';
      if (LoggingService.uConsole) {
        console.log('DynamicComponentService : Inside Pre-Auth Case with pageGroupURL :' + pageGroupUrl + ' Lineage : ' + lineage);
      }
      /* lineage = JSON.parse(this.domStorageFB.getItem('lr_json_data')).lineage.toString(); */
      lineage = this.getClientId() + '_1.0';
    }
    const options: IUrlOptions = {
      restOfUrl: '',
      endPoint: pageGroupUrl,
      isSecure: true,
      contentType: 'application/json'
    };

    // let pageImpGroups = [];
    // pageImpGroups.push({ 'assetGroup': assetGroup, asset: instanceid});

    let requestBody = {
      'lineage': lineage,
      'locale': 'en_US',
      'operation': 'configset',
      'assetKeys': assetGroup

    };
    return this.remoteService.request('post', options, requestBody).map((res: Response) => {
      //     res['intranetlink'] = this.intranetlink;
      return res;
    });

  }

/* istanbul ignore next */
public checkFlavorExpValue(flavors, pageName, queryString, isRouterLink) {
  let angularConvertedLink = null;
  const angularFirstURL = this.getAngularFirstUrl();
  const orgName = this.getOrgName();
  const flavorArray = new Array<any>();
  for (const flavour in flavors) {
      if (flavour) {
          const flavourObj = flavors[flavour];
          // if (flavourObj['flavourName'] !== 'DEFAULT') {
          flavorArray.push(flavourObj);
          // }
      }
  }
  for (const flavourObj in flavorArray) {
      if (flavourObj) {
          const routeObj = flavorArray[flavourObj];
          const flavourName = routeObj['flavourName'];
          const routeExpr = routeObj['expr'];
          if (routeExpr) {
              const customExprValue = this.domStorageFB.getItem('expValueMap');
              if (customExprValue && customExprValue !== 'undefined') {
                  const customExprValueMap = JSON.parse(customExprValue);
                  const exprValue = customExprValueMap[routeExpr];
                  if (exprValue === true) {
                      const redirectComponentPage = flavourName;
                      if (redirectComponentPage && redirectComponentPage.trim().length > 0) {
                          if (isRouterLink) {
                              // tslint:disable-next-line:max-line-length
                              angularConvertedLink = 'web/' + orgName + '/' + redirectComponentPage;
                          } else {
                              // tslint:disable-next-line:max-line-length
                              angularConvertedLink = angularFirstURL + '#/web/' + orgName + '/' + redirectComponentPage + '?' + queryString + '&flavorCheck=true';
                          }
                      } else {
                          if (isRouterLink) {
                              // tslint:disable-next-line:max-line-length
                              angularConvertedLink = 'web/' + orgName + '/' + pageName;
                          } else {
                              if (queryString === null) {
                                  // tslint:disable-next-line:max-line-length
                                  angularConvertedLink = angularFirstURL + '#/web/' + orgName + '/' + pageName + '?flavorCheck=true';
                              } else {
                                  // tslint:disable-next-line:max-line-length
                                  angularConvertedLink =  angularFirstURL + '#/web/' + orgName + '/' + pageName + '?' + queryString + '&flavorCheck=true';
                              }
                          }
                      }
                      return angularConvertedLink;
                  }
              }
          }
      }
  }
  return angularConvertedLink;
}

}
/* tslint:enable */
